import { Injectable } from '@angular/core';
import { WidgetService } from '../../services/widget/widget.service';
import { WidgetPreferencesService } from '../templateDrivenWidget/services/widget-preferences.service';
import * as _ from 'underscore';
import { Subject } from 'rxjs/Subject';
import { UserService } from '../../services/user/user.service';
import { WidgetCriteriaService } from './widget-criteria.service';
import { WidgetQuerySearchService } from './widget-query-search.service';
import { MyDetailsEvents } from '../../mydetails/mydetails.events';
import { isUndefined } from 'util';
import * as moment from 'moment';
import { IAddress } from '../../interfaces/interfaces';


@Injectable()
export class WidgetListsByPreferenceService {

  widgets: Array<any> = [];
  recommendedWidgets: Array<any> = [];
  archivedWidgets: Array<any> = [];
  favouriteWidgets: Array<any> = [];
  details: any = {};

  widgetRemoved: Subject<any> = new Subject();

  constructor(private widgetService: WidgetService,
              private widgetPreferences: WidgetPreferencesService,
              private userService: UserService,
              private widgetSearch: WidgetQuerySearchService,
              private widgetCrieria: WidgetCriteriaService,
              private myevents: MyDetailsEvents) {
    this.myevents.ageSaved.subscribe((data) => {
      const age = moment().diff(data.dob, 'years');
      this.details.age = age;
      this.filterWidgetsIntoArray('favourites');
    });

    this.myevents.postcodeSaved.subscribe((data) => {
      this.details.postcode = data.postcode;
      this.filterWidgetsIntoArray('favourites');

    });

    this.myevents.addressSaved.subscribe((data) => {
      this.details.postcode = this.extractPostcode(data);
      this.filterWidgetsIntoArray('favourites');
    });

    this.myevents.genderSaved.subscribe((data) => {
      this.details.gender = data;
      this.filterWidgetsIntoArray('favourites');
    });
  }

  getWidgetsAndPreferences(): Promise<any> {
    let promise;
    if (this.widgets.length === 0) {
      promise = Promise.all([this.widgetService.getPublicWidgets(), this.widgetPreferences.getAllWidgetPreferences()]).then((data) => {
        this.widgets = data[0];
        const widgetpreferences = data[1];
        for (const widget in widgetpreferences) {
          if (widget) {

            const index = _.findIndex(this.widgets, {id: widget});

            if (index >= 0) {
              const preferences = widgetpreferences[+widget];

              this.widgetPreferences.createSubject(this.widgets[index].widgetName);
              this.widgetPreferences.updateSubject(this.widgets[index].widgetName, preferences);
            }
          }
        }
      });
    } else {
      promise = new Promise((resolve) => {
        resolve();
      })

    }

    return promise;
  }

  getWidgetByRoute(route: string): Promise<Array<any>> {
    return new Promise((resolve) => {
      if (this.recommendedWidgets.length === 0) {

        this.getDetailsToFilterBy().then((details) => {
          this.details = details;
          this.filterWidgetsIntoArray(route);

          if (route === 'favourites') {
            resolve(this.favouriteWidgets);
          } else if (route === 'archived') {
            resolve(this.archivedWidgets);
          } else {
            resolve(this.recommendedWidgets);
          }
        });
      } else {
        if (route === 'favourites') {
          resolve(this.favouriteWidgets);
        } else if (route === 'archived') {
          resolve(this.archivedWidgets);
        } else {
          resolve(this.recommendedWidgets);
        }
      }
    });
  }

  filterWidgetsIntoArray(route) {
    this.favouriteWidgets = [];
    this.archivedWidgets = [];
    this.recommendedWidgets = [];

    const criteria = this.widgetCrieria.getCriteria(this.details.level, this.details.postcode, this.details.age, this.details.gender);
    const filteredWidgetsByCriteria = this.widgetSearch.search(this.widgets, criteria, null);
    const filteredByPostCode = this.widgetSearch.filterByPostcode(this.details.postcode, filteredWidgetsByCriteria);

    for (const widget in filteredByPostCode) {
      if (widget) {
        const widgetPreference = this.widgetPreferences.getWidgetPreferencesByName(filteredByPostCode[widget]['widgetName']);
        if (isUndefined(widgetPreference)) {
          this.recommendedWidgets.push(filteredByPostCode[widget]);
        } else {
          if (widgetPreference.archive) {
            this.archivedWidgets.push(filteredByPostCode[widget]);
          } else if (widgetPreference.favourite) {
            this.favouriteWidgets.push(filteredByPostCode[widget]);
          } else {
            this.recommendedWidgets.push(filteredByPostCode[widget]);
          }
        }

      }
    }
    if (route === 'favourites') {
      return this.favouriteWidgets;
    } else if (route === 'archived') {
      return this.archivedWidgets;
    } else {
      return this.recommendedWidgets;
    }
  }

  extractPostcode(addresses: IAddress[]) {
    const homeAddress = _.find(addresses, (address) => address.address_type === 'HOME');
    const postcode = homeAddress === undefined ? null : homeAddress.postcode;
    return postcode;
  }

  getDetailsToFilterBy() {
    return this.userService.getMyDetails(2).then((data) => {
      return { age: data.contactAge.age, gender: data.gender, postcode: this.extractPostcode(data.addresses), level: data.level};
    });
  }

  addToFavourites(widgetName: string) {
    const widgetpreference = this.widgetPreferences.widgetPreferenceData.get(widgetName);
    if (!widgetpreference.archive) {
      this.removeWidgetFromList(widgetName);
      this.addWidgetToList(widgetName, 'favourite');
    }
  }

  addToArchived(widgetName: string) {
    this.removeWidgetFromList(widgetName);
    this.addWidgetToList(widgetName, 'archived');
  }

  removeFromFavourites(widgetName: string) {
    const widgetpreference = this.widgetPreferences.widgetPreferenceData.get(widgetName);
    if (!widgetpreference.archive) {
      this.removeWidgetFromList(widgetName);
      this.addWidgetToList(widgetName, 'recommended');
    }
  }

  removeFromArchived(widgetName: string) {
    const widgetpreference = this.widgetPreferences.widgetPreferenceData.get(widgetName);
    this.removeWidgetFromList(widgetName);

    if (widgetpreference.favourite) {
      this.removeWidgetFromList(widgetName);
      this.addWidgetToList(widgetName, 'favourite');
    } else {
      this.removeWidgetFromList(widgetName);
      this.addWidgetToList(widgetName, 'recommended');
    }
  }

  removeWidgetFromList(widgetName) {
    const archived = _.findIndex(this.archivedWidgets, (widget) => {
      if (widget['widgetName'] === widgetName) {
        return true;
      }
    });

    const recommended = _.findIndex(this.recommendedWidgets, (widget) => {
      if (widget['widgetName'] === widgetName) {
        return true;
      }
    });

    const favourite = _.findIndex(this.favouriteWidgets, (widget) => {
      if (widget['widgetName'] === widgetName) {
        return true;
      }
    });

    if (archived >= 0) {
      this.archivedWidgets.splice(archived, 1);
    }

    if (recommended >= 0) {
      this.recommendedWidgets.splice(recommended, 1);
    }

    if (favourite >= 0) {
      this.favouriteWidgets.splice(favourite, 1);
    }
  }

  private addWidgetToList(widgetName: string, list: string) {
    const foundwidget = _.find(this.widgets, (widget) => {
      if (widget['widgetName'] === widgetName) {
        return true;
      }
    });

    if (foundwidget) {
      if (list === 'favourite') {
        this.favouriteWidgets.push(foundwidget)
      }

      if (list === 'archived') {
        this.archivedWidgets.push(foundwidget)
      }

      if (list === 'recommended') {
        this.recommendedWidgets.push(foundwidget)
      }

      this.widgetRemoved.next(widgetName);
    }
  }
}




// WEBPACK FOOTER //
// ./app/widgets/widgetDisplayQueries/widget-lists-by-preference.service.ts